import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { BizboxLogo } from "../../common/components/bizbox-logo";
import { BoxLogo } from "../../common/components/box-logo";
import { BizLogo } from "../../common/components/biz-logo";
//import { removeAuthorizationHeader } from "../../common/routes/auth";

const SplashScreen: React.FC = () => {
  const [showSplash, setShowSplash] = useState(true);
  const [bgColor] = useState("linear-gradient(180deg, #EAF5FE 0%, #FFFFFF 100%)");
  const navigate = useNavigate();

  useEffect(() => {
    const splashTimer = setTimeout(() => {
      setShowSplash(false);
      // removeAuthorizationHeader();
      navigate("/login", {
        replace: true,
        state: { isNavigatingInsideApplication: true }
      });
    }, 2000);

    return () => {
      clearTimeout(splashTimer);
    };
  }, [navigate]);

  return (
    <AnimatePresence mode="wait">
      {showSplash ? (
        <motion.div
          key="splash"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            height: "100vh",
            width: "100vw",
            background: bgColor,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
            margin: 0,
            padding: 0,
            overflow: "hidden",
          }}
        >
          <motion.div
            initial={{ width: 0, height: 0 }}
            animate={{ width: "100vw", height: "100vh" }}
            transition={{ delay: 1, duration: 0.5, ease: "easeInOut" }}
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              background: "white",
              transform: "translate(-50%, -50%)",
              zIndex: 1,
            }}
          />

          <Box
            sx={{
              position: "relative",
              zIndex: 2,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              m: 0,
              p: 0,
            }}
          >
            <motion.div layoutId="logo1" style={{ margin: 0, padding: 0 }}>
              <Box
                sx={{
                  width: { xs: 150, md: 200 },
                  height: { xs: 150, md: 200 },
                  m: 0,
                  p: 0,
                  display: "block",
                }}
              >
                <BizboxLogo />
              </Box>
            </motion.div>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                width: { xs: 150, md: 200 },
                marginTop: 10,
                fontSize: 0,

              }}
            >
              <motion.div
                layoutId="logo2"
                initial={{ x: "100vw" }}
                animate={{ x: 82 }}
                transition={{
                  delay: 0.5,
                  type: "spring",
                  mass: 1,
                  stiffness: 256,
                  damping: 24,
                }}
                style={{ margin: 0, padding: 0, display: "block" }}
              >
                <Box
                  sx={{
                    width: { xs: 120, md: 150 },
                    height: { xs: 120, md: 150 },
                    m: 0,
                    p: 0,
                    display: "block",
                  }}
                >
                  <BoxLogo fontSize={48} />
                </Box>
              </motion.div>
              <motion.div
                layoutId="logo3"

                initial={{ x: "-100vw" }}
                animate={{ x: -82 }}
                transition={{
                  delay: 0.5,
                  type: "spring",
                  mass: 1,
                  stiffness: 256,
                  damping: 24,
                }}
                style={{ margin: 0, padding: 0, display: "block" }}
              >
                <Box
                  sx={{
                    width: { xs: 120, md: 150 },
                    height: { xs: 120, md: 150 },
                    m: 0,
                    p: 0,
                    mr: 2,
                    display: "block",
                  }}
                >
                  <BizLogo fontSize={48} />
                </Box>
              </motion.div>
            </Box>
          </Box>
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
};

export default SplashScreen;